import { Link } from 'react-router-dom';
import { useMembership } from '../../auth/MembershipContext';
import { useFormConfig } from '../../hooks/useFormConfig';
import { canManageMembers } from '../../service/membership';
import { managedQuestions } from '../../utils/managed-options';
import { setSelectedFormIdInSession } from '../../utils/form-id';

export default function ManageValuesButton() {
  const { formConfig, tenant } = useFormConfig();
  const { me } = useMembership();
  if (tenant !== 'gfie' || !canManageMembers(me, tenant) || !managedQuestions(formConfig).length)
    return null;
  return (
    <Link
      className="govuk-button govuk-button--secondary"
      to={`/${tenant}/manage-values`}
      onClick={() => setSelectedFormIdInSession(tenant, null)}
    >
      Manage form values
    </Link>
  );
}
